// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__56QPn","header":"ReportDetails_header__2x3n0","title":"ReportDetails_title__2rlvS","left":"ReportDetails_left__2pWt7"};